import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import sellerMarketProductOrderItemTableColumns from './seller-market-product-order-item-table-columns'
import DataTable from 'components/organisms/data-table'


const proptypes = {
  data           : PropTypes.array,
  pagination     : PropTypes.object,
  onFetchData    : PropTypes.func,
  isLoading      : PropTypes.bool,
  hiddenColumns  : PropTypes.array,
  rowButtonProps : PropTypes.array
}

const defaultProps = {
  rowButtonProps: []
}


/**
 * Domain-specifc DataTable for Seller Market Product Order Item
 * @param {object} rowButtonProps - Button Props for row button
 * @param {any} props - any props for Data Table
 */
const SellerMarketProductOrderItemTable = ({
  rowButtonProps,
  ...props
}) => {

  /**
   * It's important that we're using React.useMemo
   * here to ensure that our data isn't recreated on every render.
   * see https://react-table.tanstack.com/docs/quick-start
   *
   * we destruct rowButtonProps to make sure this object only render once
   *  */
  const columns = useMemo(() => sellerMarketProductOrderItemTableColumns({ rowButtonProps }), [ rowButtonProps ])

  return (
    <DataTable { ...props } columns={ columns }/>
  )
}

SellerMarketProductOrderItemTable.propTypes    = proptypes
SellerMarketProductOrderItemTable.defaultProps = defaultProps

export default SellerMarketProductOrderItemTable
